var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Accordion, AccordionDetails, AccordionSummary, Button, makeStyles, Paper } from '@material-ui/core';
import _ from 'lodash';
import moment from 'moment';
import { useSnackbar } from 'notistack';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { fetchAdditionalFlights } from '../../../../../include/api-ito/ToursApi';
import { _T } from '../../../../../include/appI18n';
import { pluralizeAutoSplit } from '../../../../../include/utils';
import '../../../../NewTourSearch/compoments/TourSearch.css';
import { useFlightConfiguration, useTourDescription } from '../../../store/TourDescriptionStore';
import { FlightAltVariant } from './FlightAltVariant';
import { FlightInfoCompact, getRoute } from './FlightInfoCompact';
import './FlightVariants.css';
import { isCapitalUI } from '../../../../../include/react-common/theme';
import { CapitalFlightBaggage, CapitalFlightRoute, CapitalFlightTariffList } from '../../../../../include/react-components/capital/flight/CapitalFlight';
import { CapitalFlightCard, CapitalFlightCardDirection } from '../../../../../include/react-components/capital/flight/CapitalFlightCard';
import { tourFlightDirection } from '../../../../../include/react-components/capital/flight/CapitalFlightModel';
import { capitalFlightAssetBaseUrl, capitalFlightLabels, capitalFlightRetryLabel } from './CapitalFlightAdapter';
const useStyles = makeStyles(theme => ({
    accordion: {
        marginBottom: 16,
        '& .MuiCollapse-container': {
            width: '100%',
            minWidth: '100%',
            maxWidth: '100%',
        },
        '& .MuiAccordionDetails-root': {
            display: 'block',
        },
    },
}));
const FlightDetailsStop = ({ stop, index, count }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "entry" },
            React.createElement("div", { className: "vertical" }, index != 0 ? React.createElement("div", { className: "line mid dotted" }) : null),
            React.createElement("div", { className: "box start header" },
                React.createElement("div", { className: "itinerary" },
                    _T.COMMON_FLIGHT_PLANE,
                    ":\u00A0",
                    React.createElement("span", { className: "number" }, stop.flightNumber),
                    "\u00A0",
                    React.createElement("span", { className: "sep" }, "\u00B7"),
                    "\u00A0",
                    React.createElement("span", { className: "airline" }, stop.airlineName)),
                React.createElement("div", { className: "class" },
                    React.createElement("span", { className: "name" }, stop.airServiceClassName),
                    "\u00A0",
                    React.createElement("span", { className: "code" },
                        "(",
                        stop.airServiceClassAdditionalCode,
                        ")")))),
        React.createElement("div", { className: "entry" },
            React.createElement("div", { className: "vertical" },
                React.createElement("div", { className: "point" }),
                React.createElement("div", { className: "line start" }),
                index > 0 ? React.createElement("div", { className: "line end dotted" }) : null),
            React.createElement("div", { className: "box mid" },
                React.createElement("div", { className: "time-container" },
                    React.createElement("div", { className: "time" }, moment(stop.departureTime).format('HH:mm')),
                    "\u00A0",
                    React.createElement("div", { className: "timedate" }, moment(stop.departureTime).format('L'))),
                React.createElement("div", { className: "endpoint" },
                    React.createElement("div", { className: "location" },
                        React.createElement("span", { className: "city" }, stop.departureAirportCityName),
                        ",\u00A0",
                        React.createElement("span", { className: "airport" }, stop.departureAirportName)),
                    React.createElement("div", { className: "airport-code" }, stop.departureAirportCode)))),
        React.createElement("div", { className: "entry" },
            React.createElement("div", { className: "vertical" },
                React.createElement("div", { className: "line mid" }),
                React.createElement("div", { className: "clock" },
                    React.createElement("span", { className: "fa fa-clock-o" }))),
            React.createElement("div", { className: "box mid duration" }, (() => {
                const duration = stop.flightDuration;
                const hours = Math.floor(duration / 60);
                const minutes = duration % 60;
                return (React.createElement("div", { className: "duration" },
                    _T.FLIGHT_SEARCH_ADDITIONAL_FILTER_FLIGHT_DURATION,
                    ":",
                    React.createElement("span", { className: "nobr" },
                        React.createElement("span", null, ` ${hours}`),
                        " ",
                        pluralizeAutoSplit(hours, _T.COMMON_HOURS_SHORT),
                        " ",
                        React.createElement("span", null, minutes),
                        " ",
                        pluralizeAutoSplit(minutes, _T.COMMON_MINUTES_SHORT))));
            })())),
        React.createElement("div", { className: "entry" },
            React.createElement("div", { className: "vertical" },
                React.createElement("div", { className: "point" }),
                React.createElement("div", { className: "line end" }),
                index + 1 < count ? React.createElement("div", { className: "line start dotted" }) : null),
            React.createElement("div", { className: "box end" },
                React.createElement("div", { className: "time-container" },
                    React.createElement("div", { className: "time" }, moment(stop.arrivalTime).format('HH:mm')),
                    React.createElement("div", { className: "timedate" }, moment(stop.arrivalTime).format('L'))),
                React.createElement("div", { className: "endpoint" },
                    React.createElement("div", { className: "location" },
                        React.createElement("span", { className: "city" }, stop.arrivalAirportCityName),
                        ",\u00A0",
                        React.createElement("span", { className: "airport" }, stop.arrivalAirportName)),
                    React.createElement("div", { className: "airport-code" }, stop.arrivalAirportCode))))));
};
export const FlightDetailsOneWay = ({ direction, selectedPrice }) => {
    var _a, _b, _c, _d;
    if (isCapitalUI)
        return React.createElement(CapitalFlightRoute, { direction: direction, variant: selectedPrice, labels: capitalFlightLabels, assetBaseUrl: capitalFlightAssetBaseUrl });
    const { first, last, stops, route } = direction == 'forward' ? {
        first: selectedPrice.forwardStops[0],
        last: selectedPrice.forwardStops[selectedPrice.forwardStops.length - 1],
        stops: selectedPrice.forwardStops,
        route: getRoute(selectedPrice.forwardStops),
    } : {
        first: !((_a = selectedPrice.returnStops) === null || _a === void 0 ? void 0 : _a.length) ? undefined : selectedPrice.returnStops[0],
        last: !((_b = selectedPrice.returnStops) === null || _b === void 0 ? void 0 : _b.length) ? undefined : selectedPrice.returnStops[selectedPrice.returnStops.length - 1],
        stops: !((_c = selectedPrice.returnStops) === null || _c === void 0 ? void 0 : _c.length) ? [] : selectedPrice.returnStops,
        route: !((_d = selectedPrice.returnStops) === null || _d === void 0 ? void 0 : _d.length) ? [] : getRoute(selectedPrice.returnStops),
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "direction" },
            React.createElement("h3", null,
                React.createElement("span", null, direction == 'forward' ? _T.FLIGHT_SEARCH_ADDITIONAL_FILTER_DIRECTION_FORWARD_2 : _T.FLIGHT_SEARCH_ADDITIONAL_FILTER_DIRECTION_RETURN),
                " \u00A0 (",
                React.createElement("span", null, first === null || first === void 0 ? void 0 : first.departureAirportCode),
                " \u2014 ",
                React.createElement("span", null, last === null || last === void 0 ? void 0 : last.arrivalAirportCode),
                ")"),
            React.createElement("div", { className: "overall" },
                React.createElement("span", { className: "fa fa-clock-o" }),
                " \u00A0",
                (() => {
                    const duration = direction == 'forward' ? selectedPrice.forwardFlightDuration : selectedPrice.returnFlightDuration;
                    const hours = Math.floor(duration / 60);
                    const minutes = duration % 60;
                    return (React.createElement(React.Fragment, null,
                        React.createElement("span", null, ` ${hours}`),
                        " ",
                        pluralizeAutoSplit(hours, _T.COMMON_HOURS_SHORT),
                        " ",
                        React.createElement("span", null, minutes),
                        " ",
                        pluralizeAutoSplit(minutes, _T.COMMON_MINUTES_SHORT)));
                })())),
        React.createElement("div", { className: "details" }, (direction == 'forward' ? selectedPrice.forwardStops : selectedPrice.returnStops || []).map((stop, i, a) => (React.createElement(React.Fragment, null,
            React.createElement(FlightDetailsStop, { stop: stop, index: i, key: i, count: a.length }),
            i + 1 < a.length ?
                React.createElement("div", { className: "entry" },
                    React.createElement("div", { className: "vertical" },
                        React.createElement("div", { className: "line mid dotted" }),
                        React.createElement("div", { className: "warning" },
                            React.createElement("span", { className: "fa fa-warning" }))),
                    React.createElement("div", { className: "box transfer" },
                        React.createElement("span", null, _T.FLIGHT_SEARCH_TRANSFER),
                        " \u00A0",
                        (() => {
                            const duration = stop.stopDuration;
                            const hours = Math.floor(duration / 60);
                            const minutes = duration % 60;
                            return (React.createElement("span", { className: "duration" },
                                React.createElement("span", null, ` ${hours}`),
                                " ",
                                pluralizeAutoSplit(hours, _T.COMMON_HOURS_SHORT),
                                " ",
                                React.createElement("span", null, minutes),
                                " ",
                                pluralizeAutoSplit(minutes, _T.COMMON_MINUTES_SHORT)));
                        })())) : null))))));
};
export const FlightResultCard = ({ isFrame, flightIndex, group, current, onFlightSelect, className, onAltMoreDetailed, dialogRef }) => {
    var _a, _b, _c, _d;
    const classes = useStyles();
    const snackbar = useSnackbar();
    const [{ flightConfiguration }] = useFlightConfiguration(isFrame);
    const [{ hash }] = useTourDescription(isFrame);
    const [selectedPrice, setSelectedPrice] = useState(group.selectedPrice);
    const isCurrentGroup = useMemo(() => group.prices.map(p => p.flightId).indexOf((current === null || current === void 0 ? void 0 : current.flightId) || '') >= 0, [group.groupHash, group.prices, current === null || current === void 0 ? void 0 : current.flightId]);
    const groupPrices = useMemo(() => group.prices.map(p => (Object.assign(Object.assign({}, p), { isCurrent: selectedPrice.flightId == p.flightId }))), [selectedPrice, group.prices, group.groupHash]);
    useEffect(() => {
        var _a, _b;
        if (!isCurrentGroup && group.prices.find(p => p.flightId == (selectedPrice === null || selectedPrice === void 0 ? void 0 : selectedPrice.flightId)))
            return;
        setSelectedPrice((_b = (_a = group.prices.find(p => p.flightId == (current === null || current === void 0 ? void 0 : current.flightId))) !== null && _a !== void 0 ? _a : group.selectedPrice) !== null && _b !== void 0 ? _b : group.prices[0]);
    }, [group.groupHash]);
    useEffect(() => {
        group.selectedPrice = selectedPrice;
    }, [selectedPrice.flightId]);
    const additionalVariantsRequestId = useRef(0);
    const [additionalVariantsState, setAdditionalVariantsState] = useState('none');
    const [additionalVariants, setAdditionalVariants] = useState([]);
    const [expanded, setExpanded] = React.useState(false);
    const additionalVariantPrices = useMemo(() => additionalVariants.map(p => (Object.assign(Object.assign({}, p), { isCurrent: selectedPrice.flightId == p.flightId }))), [selectedPrice, additionalVariants, group.groupHash]);
    const loadAdditionalVariants = () => __awaiter(void 0, void 0, void 0, function* () {
        const requestId = ++additionalVariantsRequestId.current;
        if (!selectedPrice.hasVariants) {
            setAdditionalVariants([]);
            setAdditionalVariantsState('loaded');
            return;
        }
        setAdditionalVariantsState('loading');
        try {
            const response = yield fetchAdditionalFlights(hash, selectedPrice);
            if (requestId != additionalVariantsRequestId.current)
                return;
            if ('errors' in response) {
                console.error(`Couldn't load additional flights`);
                console.error(response);
                setAdditionalVariantsState('failed');
            }
            else {
                setAdditionalVariants(response.prices);
                setAdditionalVariantsState('loaded');
            }
        }
        catch (e) {
            if (requestId != additionalVariantsRequestId.current)
                return;
            console.error(`Couldn't load additional flights`);
            console.error(e);
            setAdditionalVariantsState('failed');
        }
    });
    useEffect(() => {
        additionalVariantsRequestId.current++;
        setAdditionalVariants([]);
        setAdditionalVariantsState('none');
    }, [hash, selectedPrice.flightId]);
    useEffect(() => {
        if (expanded && additionalVariantsState == 'none' && selectedPrice.hasVariants)
            loadAdditionalVariants();
    }, [expanded, additionalVariantsState, hash, selectedPrice.flightId, selectedPrice.hasVariants]);
    const handleChange = (_, isExpanded) => {
        setExpanded(isExpanded);
    };
    const FlightDetailsMoreVariants = () => {
        if (!selectedPrice.hasVariants)
            return null;
        if (additionalVariantsState == 'loaded' && additionalVariants.length == 0)
            return null;
        return (React.createElement("div", { className: "details" },
            React.createElement("h4", null, _T.FLIGHT_SEARCH_ADDITIONAL_VARIANTS),
            React.createElement(Paper, { elevation: 2, className: "additional-variants" }, additionalVariantsState == 'loaded' && additionalVariants.length > 0 ?
                React.createElement("div", { className: "alt-variants-grid" }, additionalVariantPrices.map((v, i) => React.createElement(FlightAltVariant, { group: group, variant: v, isCurrent: v.isCurrent, currentInGroup: selectedPrice, isFrame: isFrame, onSelect: setSelectedPrice, key: i, onAltMoreDetailed: onAltMoreDetailed }))) :
                React.createElement("div", { className: "text-center py-3" }, additionalVariantsState == 'loading' || additionalVariantsState == 'none' ?
                    React.createElement("span", { className: "fa fa-spinner fa-spin fa-2x" }) :
                    React.createElement(React.Fragment, null, _T.FLIGHT_SEARCH_ADDITIONAL_VARIANTS_LOADING_FAILED)))));
    };
    const rootRef = useRef(null);
    if (isCapitalUI)
        return React.createElement(CapitalFlightCard, { ref: rootRef, selected: isCurrentGroup, expanded: expanded, onExpand: () => setExpanded(!expanded), onBook: () => { void onFlightSelect(selectedPrice); }, chooseLabel: _T.COMMON_CHOOSE, detailsLabel: _T.FLIGHT_SEARCH_MORE_DETAILS, assetBaseUrl: capitalFlightAssetBaseUrl, detailsId: `capital-flight-details-${flightIndex}`, directions: React.createElement(React.Fragment, null, ['forward', 'return'].map(direction => {
                const route = tourFlightDirection(selectedPrice, direction);
                return route ? React.createElement(CapitalFlightCardDirection, { key: direction, route: route, label: direction === 'forward' ? capitalFlightLabels.forward : capitalFlightLabels.return, labels: capitalFlightLabels, assetBaseUrl: capitalFlightAssetBaseUrl, showFlightNumbers: !!flightConfiguration.showFlightNumbersInCardMainArea, baggage: React.createElement(CapitalFlightBaggage, { variant: selectedPrice, labels: capitalFlightLabels, assetBaseUrl: capitalFlightAssetBaseUrl, seatsWarningUpperBoundary: flightConfiguration.seatsWarningUpperBoundary }) }) : null;
            })), fares: React.createElement(CapitalFlightTariffList, null, groupPrices.map(variant => React.createElement(FlightAltVariant, { key: variant.flightId, variant: variant, group: group, isCurrent: variant.isCurrent, currentInGroup: selectedPrice, isFrame: isFrame, onSelect: setSelectedPrice, onAltMoreDetailed: onAltMoreDetailed }))), details: React.createElement(React.Fragment, null,
                selectedPrice.hasVariants && !(additionalVariantsState === 'loaded' && additionalVariants.length === 0) ? React.createElement(React.Fragment, null,
                    React.createElement("h4", null, _T.FLIGHT_SEARCH_ADDITIONAL_VARIANTS),
                    additionalVariantsState === 'loaded' ? React.createElement(CapitalFlightTariffList, null, additionalVariantPrices.map(variant => React.createElement(FlightAltVariant, { key: variant.flightId, variant: variant, group: group, isCurrent: variant.isCurrent, currentInGroup: selectedPrice, isFrame: isFrame, onSelect: setSelectedPrice, onAltMoreDetailed: onAltMoreDetailed })))
                        : React.createElement("div", { className: "capital-flight-loading", role: additionalVariantsState === 'failed' ? 'alert' : 'status' }, additionalVariantsState === 'failed' ? React.createElement(React.Fragment, null,
                            React.createElement("p", null, _T.FLIGHT_SEARCH_ADDITIONAL_VARIANTS_LOADING_FAILED),
                            React.createElement(Button, { color: "primary", variant: "outlined", onClick: loadAdditionalVariants }, capitalFlightRetryLabel)) : React.createElement("span", { className: "fa fa-spinner fa-spin" }))) : null,
                React.createElement(FlightDetailsOneWay, { direction: "forward", selectedPrice: selectedPrice }),
                ((_a = selectedPrice.returnStops) === null || _a === void 0 ? void 0 : _a.length) ? React.createElement(FlightDetailsOneWay, { direction: "return", selectedPrice: selectedPrice }) : null) });
    return (React.createElement(Accordion, { ref: rootRef, key: flightIndex, className: `${className} ${classes.accordion}${isCurrentGroup ? ' selected' : ''}`, expanded: expanded, onChange: handleChange },
        React.createElement(AccordionSummary, { classes: { content: 'flight-result' } },
            React.createElement("div", { className: "main-container" },
                React.createElement("div", { className: "main" },
                    React.createElement(FlightInfoCompact, { className: "oneway", direction: "forward", variant: selectedPrice, isFrame: isFrame }),
                    React.createElement("hr", null),
                    ((_b = group.prices[0].returnStops) === null || _b === void 0 ? void 0 : _b.length) ? React.createElement(React.Fragment, null,
                        React.createElement(FlightInfoCompact, { className: "oneway", direction: "return", variant: selectedPrice, isFrame: isFrame }),
                        React.createElement("hr", { className: "summary-sep" })) : null,
                    React.createElement("div", { className: "summary" },
                        React.createElement("div", null,
                            React.createElement("span", { className: "airline fa fa-arrow-right" }),
                            "\u00A0",
                            Object.entries(_.groupBy(group.prices[0].forwardStops, s => s.airlineName)).map(x => ({ airlineName: x[0], stops: x[1] })).map((x, xi, array) => (React.createElement(React.Fragment, null,
                                React.createElement("span", { className: "airline" }, x.airlineName),
                                "\u00A0",
                                flightConfiguration.showFlightNumbersInCardMainArea ? React.createElement(React.Fragment, null,
                                    React.createElement("span", { className: "airline" },
                                        x.stops.length ? `(` : null,
                                        x.stops.map((s, si) => (React.createElement(React.Fragment, null,
                                            React.createElement("span", null, s.flightNumber),
                                            si + 1 < x.stops.length ? `| ` : null))),
                                        x.stops.length ? `()`.substring(1) : null)) : null,
                                xi + 1 < array.length ? ` · ` : null)))),
                        ((_c = group.prices[0].returnStops) === null || _c === void 0 ? void 0 : _c.length) ?
                            React.createElement("div", null,
                                React.createElement("span", { className: "airline fa fa-arrow-left" }),
                                "\u00A0",
                                Object.entries(_.groupBy(group.prices[0].returnStops, s => s.airlineName)).map(x => ({ airlineName: x[0], stops: x[1] })).map((x, xi, array) => (React.createElement(React.Fragment, null,
                                    React.createElement("span", { className: "airline" }, x.airlineName),
                                    "\u00A0",
                                    flightConfiguration.showFlightNumbersInCardMainArea ? React.createElement(React.Fragment, null,
                                        React.createElement("span", { className: "airline" },
                                            x.stops.length ? `(` : null,
                                            x.stops.map((s, si) => (React.createElement(React.Fragment, null,
                                                React.createElement("span", null, s.flightNumber),
                                                si + 1 < x.stops.length ? `| ` : null))),
                                            x.stops.length ? `()`.substring(1) : null)) : null,
                                    xi + 1 < array.length ? ` · ` : null)))) : null))),
            React.createElement("div", { className: "alt-variants", onClick: (e) => e.stopPropagation() },
                React.createElement("div", { className: "alt-variants-grid" }, groupPrices.map(variant => React.createElement(FlightAltVariant, { key: variant.flightId, variant: variant, group: group, isCurrent: variant.isCurrent, currentInGroup: selectedPrice, isFrame: isFrame, onSelect: setSelectedPrice, onAltMoreDetailed: onAltMoreDetailed }))),
                React.createElement(Button, { className: "alt-variant-confirm-btn", color: "primary", variant: "contained", onClick: (event) => {
                        event.stopPropagation();
                        onFlightSelect(selectedPrice);
                    }, onFocus: (event) => event.stopPropagation() }, _T.COMMON_CHOOSE)),
            !expanded ?
                React.createElement("div", { className: "indicator", onClick: () => handleChange(undefined, true) },
                    React.createElement("span", { className: "fa fa-chevron-down" })) : null),
        React.createElement(AccordionDetails, { style: { width: '100%' }, className: "details-container" },
            React.createElement(FlightDetailsMoreVariants, null),
            React.createElement(FlightDetailsOneWay, { direction: "forward", selectedPrice: selectedPrice }),
            ((_d = selectedPrice.returnStops) === null || _d === void 0 ? void 0 : _d.length) ? React.createElement(FlightDetailsOneWay, { direction: "return", selectedPrice: selectedPrice }) : null,
            React.createElement("div", { className: "minimize", onClick: () => {
                    var _a;
                    const dialogBody = (_a = dialogRef.current) === null || _a === void 0 ? void 0 : _a.getElementsByClassName('MuiDialog-scrollBody')[0];
                    if (rootRef.current && dialogBody)
                        dialogBody.scrollBy({ top: rootRef.current.offsetTop - dialogBody.scrollTop + 25, behavior: 'smooth' });
                    handleChange(undefined, false);
                } },
                React.createElement("a", { href: "#" },
                    React.createElement("span", { className: "fa fa-chevron-up" }))))));
};
